import React, { useEffect, useState } from "react";
import { Table, Button, Flex, message, Space, Popconfirm, Typography, Tooltip, Select, Spin } from "antd";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { downloadFileHandle } from "../../utils/commonFunc";
import UserEdit from "./UserEdit";
import axios from "axios";
import dayjs from "dayjs";

function UsersList({ isLoading }) {
    const [isEditModal, setIsEditModal] = useState(false)
    const [editData, seteditData] = useState(null);
    const [userList, setUserList] = useState();
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        fetchList()
    }, []);

    const columns = [
        {
            title: "#",
            dataIndex: "count",
            key: "count",
            fixed: 'left',
            width: "50px"
        },
        {
            title: "Name",
            dataIndex: "fullname",
            key: "name",
            fixed: 'left',
            width: "350px"
        },
        {
            title: "Created Date",
            dataIndex: "date",
            key: "date",
            width: "190px",
        },
        {
            title: "Email",
            dataIndex: "email",
            fixed: 'left',
            key: "email",
        },
        {
            title: "User Code",
            dataIndex: "userCode",
            key: "userCode",
            width: "120px",
        },
        {
            title: "Status",
            key: "leadRequestStatus",
            dataIndex: "leadRequestStatus",
            render: (e, rec) => (
                <>
                    <Select
                        defaultValue={e}
                        value={e}
                        style={{ width: "100%" }}
                        onChange={(val) => statusChange(val, rec)}
                        options={[
                            { value: "CALLING", label: "Calling" },
                            { value: "IN_DISCUSSION", label: "In-discussion" },
                            { value: "CONVERTED", label: "Converted" },
                        ]}
                    />
                </>
            ),
            width: "160px",
        },
        {
            title: "Phone number",
            dataIndex: "phoneNumber",
            key: "phoneNo",
            width: "180px",
        },
        {
            title: "Date of Birth",
            dataIndex: "dob",
            key: "dob",
            width: "190px",
        },
        {
            title: "Action",
            key: "action",
            dataIndex: "action",
            width: "80px",
            render: (e, rec) => {
                return (
                    <Space>
                        {/* <Button type="default" icon={<EditOutlined />} size={"middle"} onClick={() => { seteditData(rec); setIsEditModal(true) }} /> */}
                        <Popconfirm
                            description="Are you sure you want to close this account?"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => deleteUser(rec.key)}
                        >
                            <Tooltip title="Deactivate account status and bot status to close this account">
                                <Button icon={<CloseOutlined />} danger size={"middle"} />
                            </Tooltip>
                        </Popconfirm>
                    </Space>
                )
            }

        },
    ].filter(Boolean);

    const statusChange = (val, rec) => {
        axios
            .post(
                `${process.env.REACT_APP_ADMIN_API_URL}admin/lead-status`,
                {
                    userId: rec?.key,
                    leadRequestStatus: val,
                },
                {
                    headers: {
                        "x-product-type": "PIP_GRID",
                    },
                }
            )
            .then((res) => {
                message.success(res.data.message || "Status updated successfully!");
                fetchList({});
            })
            .catch((e) => {
                message.error(e?.response?.data?.error || e.message || "An error occurred");
            });
    };

    const deleteUser = (id) => {
        setLoading(true)
        axios.delete(`${process.env.REACT_APP_ADMIN_API_URL}admin/delete-user/${id}`, {
            headers: {
                'x-product-type': 'PIP_GRID'
            }
        })
            .then((res) => {
                fetchList({});
                message.success(res.message || "User Deleted");
                setLoading(false)
            })
            .catch(e => {
                message.error(e.message);
            });
    };

    const fetchList = (val) => {
        axios.get(`${process.env.REACT_APP_ADMIN_API_URL}admin/lead-list`, {
            headers: {
                'x-product-type': 'PIP_GRID'
            }
        })
            .then(res => {
                const data = res.data.leads.map((dt, i) => ({
                    count: `${i + 1}`,
                    key: dt?._id,
                    fullname: `${dt?.fullName || ''}`,
                    phoneNumber: dt?.phoneNumber || '-',
                    dob: dt?.dob && dayjs(dt.dob).isValid() ? dayjs(dt.dob).format("DD-MM-YYYY") : "-",
                    email: dt?.email || '-',
                    status: dt?.loginRequestStatus && "Pending",
                    city: dt?.city || '',
                    state: dt?.state || '',
                    leadRequestStatus: dt?.leadRequestStatus === "PENDING"
                        ? "Pending"
                        : dt?.leadRequestStatus || '',
                    country: dt?.country || '',
                    productName: dt?.productName,
                    userCode: dt?.userCode,
                    date: dt?.created_at && dayjs(dt.created_at).isValid() ? dayjs(dt.created_at).format("DD-MM-YYYY") : "-"
                }));
                setUserList(data)
            }).catch(e => {
                console.log(e);
            })
    }

    return (
        <Spin spinning={loading} size="large">
            <Typography.Title level={3} className="page-title">Leads</Typography.Title>

            <Flex justify="end" gap={5} style={{ marginBottom: "20px" }}>
                <Button type="primary" onClick={() => downloadFileHandle(userList, 'users')}>
                    Download
                </Button>
            </Flex>
            <Table loading={isLoading} columns={columns} dataSource={userList} scroll={{ x: 'max-content' }} />
            {isEditModal && (
                <UserEdit
                    editData={editData}
                    isLoading={false}
                    onClose={() => setIsEditModal(false)}
                    fetchList={fetchList}
                    type='leads'
                />
            )}
        </Spin>
    );
}

const mapStateToProps = ({ login, loading }) => {
    const { permission, user } = login
    const { isLoading } = loading
    return { permission, user, isLoading }
}

export default connect(mapStateToProps, {})(UsersList);